// DOCTOR REGISTRATION Wizard Store

const state = {
  modalities: [],
  observations: [],
  dxcards: [],
  filteredDxCards: []
};

const getters = {
  dxModalities: state => {
    return state.modalities;
  },
  dxObservations: state => {
    return state.observations;
  },
  dxCards: state => {
    return state.dxcards;
  },
  filteredDxCards: state => {
    return state.filteredDxCards;
  }
};

const mutations = {
  storeModalities(state, payload) {
    state.modalities = payload;
  },
  storeObservations(state, payload) {
    state.observations = payload;
  },
  storeDxCards(state, payload) {
    state.dxcards = payload;
    state.filteredDxCards = payload;
  },
  SET_DXCARDS(state, payload) {
    const filteredCards = state.dxcards.filter(
      card => card.observation.toLowerCase() === payload.observationType.toLowerCase()
    );
    payload.observationType.toLowerCase() === "all"
      ? (state.filteredDxCards = state.dxcards)
      : (state.filteredDxCards = filteredCards);
  }
};

const actions = {
  loadModalities({ commit }) {
    return new Promise((resolve, reject) => {
      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/m_list`;
      const config = { headers: { "Content-Type": "application/json" } };

      window.axios
        .get(url, config)
        .then(response => {
          resolve(response.data);
          commit("storeModalities", response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  loadObservations({ commit }) {
    return new Promise((resolve, reject) => {
      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/o_list`;
      const config = { headers: { "Content-Type": "application/json" } };

      window.axios
        .get(url, config)
        .then(response => {
          resolve(response.data);
          commit("storeObservations", response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  loadDxCards({ commit }, payload) {
    // console.log("loadDxCards Payload:", payload)
    if (payload == null || payload == undefined || payload == "all") {
      return;
    }
    return new Promise((resolve, reject) => {
      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/m_fdrx/` + payload;
      const config = { headers: { "Content-Type": "application/json" } };

      // console.log("GetDxCards:", url)

      window.axios
        .get(url, config)
        .then(response => {
          resolve(response.data);
          commit("storeDxCards", response.data);;
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  searchDxCards({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/dxSearch`;
      const config = {
        headers: { "Content-Type": "application/json" },
        params: { term: payload }
      };

      window.axios
        .get(url, config)
        .then(response => {
          resolve(response.data);
          commit("storeDxCards", response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveDxCard({ commit }, payload) {
    // console.log("saveDxCard Payload:", payload)
    return new Promise((resolve, reject) => {
      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/dxSave`;
      const config = { headers: { "Content-Type": "application/json" } };
      const data = JSON.stringify(payload);

      window.axios
        .put(url, data, config)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteDxCard({ commit }, id) {
    return new Promise((resolve, reject) => {
      const url = `${String(process.env.VUE_APP_URL)}/dx-cards/delete/${id}`;
      const config = { headers: { "Content-Type": "application/json" } };

      window.axios
        .delete(url, config)
        .then((response) => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
